import api from "./api";

export const getMonthlyListenerFactor = async (number: any) => {
  const response = await api.get(
    `/api/monthly-listeners-factor?monthly_listeners=${number}`
  );
  return response;
};
